import logo from '../../assets/feedaia-dark-logo.svg';
import { OnboardingBlock, FormCol } from './OnboardingTemplate.styles';

function OnboardingTemplate({ children }) {
  return (
    <OnboardingBlock>
      <FormCol>
        <div className="form-content">
          <a className="brand_logo" href="https://google.com">
            <img src={logo} width="169" alt="logo" />
          </a>
          {children}
        </div>
      </FormCol>
    </OnboardingBlock>
  );
}

export default OnboardingTemplate;
